import { Action } from '@ngrx/store';
import { News } from '@fairandsmart/types';
import { FsErrorResponse } from '@fairandsmart/angular';

export enum NewsActionTypes {

  RefreshNews = '[News Panel] Refresh news',

  ShowNews = '[Header] Show news',
  LoadNews = '[News Panel] Load news',
  LoadNewsSuccess = '[News API] Load news success',
  LoadNewsFailure = '[News API] Load news failure',

  MarkNewsAsRead = '[News Card] Mark news as read',
  MarkNewsAsUnread = '[News Card] Mark news as unread',
}

export class RefreshNews implements Action {
  readonly type = NewsActionTypes.RefreshNews;
}

export class ShowNews implements Action {
  readonly type = NewsActionTypes.ShowNews;
}

export class LoadNews implements Action {
  readonly type = NewsActionTypes.LoadNews;
}

export class LoadNewsSuccess implements Action {
  readonly type = NewsActionTypes.LoadNewsSuccess;

  constructor(public payload: { response: News[], newsToRead: number }) {}
}

export class LoadNewsFailure implements Action {
  readonly type = NewsActionTypes.LoadNewsFailure;

  constructor(public payload: { response: FsErrorResponse }) {}
}

export class MarkNewsAsRead implements Action {
  readonly type = NewsActionTypes.MarkNewsAsRead;

  constructor(public payload: { newsId: string }) {}
}

export class MarkNewsAsUnread implements Action {
  readonly type = NewsActionTypes.MarkNewsAsUnread;

  constructor(public payload: { newsId: string }) {}
}

export type NewsActions =
  RefreshNews
  | ShowNews
  | LoadNews
  | LoadNewsSuccess
  | LoadNewsFailure
  | MarkNewsAsRead
  | MarkNewsAsUnread;
